import { Routes } from '@angular/router';
import { AppRoute } from '@enums';
import { authGuard } from '@guards';
import { COMMUNITIES_ROUTES } from './pages/communities';

export const routes: Routes = [
    {
        path: AppRoute.Root.Auth,
        loadComponent: () =>
            import('./layouts/success-card').then((m) => m.SuccessCardLayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('./pages/auth').then((m) => m.AuthPageComponent)
            }
        ]
    },
    {
        path: AppRoute.Root.FinishPasswordlessSignIn,
        loadComponent: () =>
            import('./layouts/success-card').then((m) => m.SuccessCardLayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./pages/finish-passwordless-sign-in').then(
                        (m) => m.FinishPasswordlessSignInPageComponent
                    )
            }
        ]
    },
    {
        path: AppRoute.Root.LinkAccount,
        loadComponent: () =>
            import('./layouts/success-card').then((m) => m.SuccessCardLayoutComponent),
        canActivate: [authGuard()],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./pages/link-account').then((m) => m.LinkAccountPageComponent)
            },
            {
                path: ':platform',
                loadComponent: () =>
                    import('./pages/link-account').then((m) => m.LinkAccountPageComponent)
            }
        ]
    },
    {
        path: '',
        loadComponent: () => import('./layouts/main').then((m) => m.AppLayoutComponent),
        canActivate: [authGuard()],
        children: [
            {
                path: AppRoute.Root.Home,
                loadComponent: () => import('./pages/home').then((m) => m.HomePageComponent)
            },
            {
                path: AppRoute.Root.Billing,
                loadComponent: () => import('./pages/billing').then((m) => m.BillingPageComponent)
            },
            {
                path: AppRoute.Root.Communities,
                children: COMMUNITIES_ROUTES
            },
            {
                path: AppRoute.Root.Api,
                loadComponent: () => import('./pages/api').then((m) => m.ApiPageComponent)
            },
            {
                path: AppRoute.Root.Settings,
                loadComponent: () => import('./pages/settings').then((m) => m.SettingsPageComponent)
            },
            {
                path: '**',
                redirectTo: AppRoute.Root.Home
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
